/* PK cart guard: a free gift (line property _pk_gift = main product id, _pk_min = cushions needed)
   stays in the cart only while the cart holds that many of the main product, and never more than 1 each. */
(function () {
  if (window.__pkGuard) return; window.__pkGuard = true;
  var nativeFetch = window.fetch.bind(window), busy = false, again = false;
  function json(r) { return r.json(); }
  function check() {
    if (busy) { again = true; return; }
    busy = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(json).then(function (c) {
      var have = {}, upd = {}, n = 0;
      c.items.forEach(function (i) { if (!(i.properties || {})._pk_gift) have[i.product_id] = (have[i.product_id] || 0) + i.quantity; });
      c.items.forEach(function (i) {
        var p = i.properties || {}; if (!p._pk_gift) return;
        var q = (have[+p._pk_gift] || 0) >= (+p._pk_min || 1) ? Math.min(i.quantity, 1) : 0;
        if (q !== i.quantity) { upd[i.key] = q; n++; }
      });
      if (!n) return false;
      return nativeFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) }).then(function () { return true; });
    }).then(function (changed) {
      busy = false;
      if (changed) {
        if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        document.dispatchEvent(new CustomEvent('pk:cart-guarded'));
      }
      if (again) { again = false; check(); }
    }).catch(function () { busy = false; });
  }
  window.fetch = function (u, o) {
    var res = nativeFetch(u, o), url = String((u && u.url) || u);
    if (/\/cart\/(change|update|add|clear)(\.js)?/.test(url)) res.then(function () { setTimeout(check, 60); }, function () {});
    return res;
  };
  // Dawn submits the cart page form on checkout: check once more before leaving.
  document.addEventListener('DOMContentLoaded', check);
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
})();
